import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper, Typography, Box } from '@mui/material';
import {
  ContentCut as ServicesIcon,
  EventNote as BookingsIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

const StatCard = ({ title, icon, color, onClick }) => (
  <Paper
    onClick={onClick}
    sx={{
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      bgcolor: color,
      color: 'white',
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 4
      }
    }}
  >
    <Box sx={{ fontSize: 48, mb: 1 }}>
      {icon}
    </Box>
    <Typography variant="h6" component="div">
      {title}
    </Typography>
  </Paper>
);

const AdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Bem-vindo ao painel administrativo da Barba
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard
            title="Serviços"
            icon={<ServicesIcon fontSize="inherit" />}
            color="#1976d2"
            onClick={() => navigate('/services')}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard
            title="Agendamentos"
            icon={<BookingsIcon fontSize="inherit" />}
            color="#2e7d32"
            onClick={() => navigate('/bookings')}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard
            title="Configurações"
            icon={<SettingsIcon fontSize="inherit" />}
            color="#ed6c02"
            onClick={() => navigate('/settings')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
